//libs
import React, { memo } from 'react';

//components
import API from 'shared/layouts/Listing/Desktop/components/API';
import Meta from 'shared/layouts/Listing/Desktop/components/Meta';
import Content from 'shared/layouts/Listing/Desktop/components/Content';
import ErrorWrapper from 'shared/layouts/Listing/ErrorWrapperV2';
import Analytics from 'shared/layouts/Listing/Desktop/components/AnalyticsV2';

interface ContainerProps {
  isSearch: boolean;
}
const Container = ({ isSearch = false }: ContainerProps) => {
  return (
    <ErrorWrapper>
      <API>
        <Meta isSearch={isSearch} />
        <Analytics />
        <Content />
      </API>
    </ErrorWrapper>
  );
};

export default memo(Container);
